import api from '../../boot/openapi';
import ApiError from './error';

const OrderService = {
  async post(order) {
    const client = await api.getClient();
    try {
      return await client.registerKioskPayment(null, order);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async initPosPayment() {
    const client = await api.getClient();
    try {
      return await client.initPosPayment(null);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getPosPaymentStatus({ invoiceId }) {
    const client = await api.getClient();
    try {
      return await client.getPosPaymentStatus(invoiceId);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async getPosPoiStatus({ terminalId }) {
    const client = await api.getClient();
    try {
      return await client.getPosPoiStatus(terminalId);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default OrderService;
